import { render, staticRenderFns } from "./blackOrWhiteRecord.vue?vue&type=template&id=958addd4&scoped=true&"
import script from "./blackOrWhiteRecord.vue?vue&type=script&lang=js&"
export * from "./blackOrWhiteRecord.vue?vue&type=script&lang=js&"
import style0 from "./blackOrWhiteRecord.vue?vue&type=style&index=0&id=958addd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958addd4",
  null
  
)

export default component.exports